import SettingsIcon from '@assets/vectors/settings.inline.svg';

import QuickLink from '.';

const Profile: QuickLink = ({ header, description }) => {
	return {
		Icon: SettingsIcon,
		header,
		description,
		pathName: '/app/member/account',
	};
};

export default Profile;
